import { create } from 'zustand';

export type AdConsent = 'granted' | 'denied' | null;

const KEY = 'ts_ad_consent';
// Separat fra Google-samtykket over — dette gjelder Toolshare sine egne,
// direkte solgte sponsorannonser (SponsorBanner.tsx), som ikke bruker noen
// sporingscookies i det hele tatt. Standard PÅ (motsatt av Google-samtykket,
// som standard er ubesvart) siden dette ikke er et cookie-samtykke som
// juridisk krever et eksplisitt, forhåndsavslått valg.
const SPONSOR_KEY = 'ts_sponsor_consent';

interface ConsentState {
  adConsent: AdConsent;
  bannerOpen: boolean;
  sponsorConsent: boolean;
  setAdConsent: (value: 'granted' | 'denied') => void;
  reopenBanner: () => void;
  setSponsorConsent: (value: boolean) => void;
}

export const useConsent = create<ConsentState>((set) => ({
  adConsent: (localStorage.getItem(KEY) as AdConsent) || null,
  bannerOpen: !localStorage.getItem(KEY),
  sponsorConsent: localStorage.getItem(SPONSOR_KEY) !== 'denied',
  setAdConsent: (value) => {
    localStorage.setItem(KEY, value);
    set({ adConsent: value, bannerOpen: false });
  },
  reopenBanner: () => set({ bannerOpen: true }),
  setSponsorConsent: (value) => {
    localStorage.setItem(SPONSOR_KEY, value ? 'granted' : 'denied');
    set({ sponsorConsent: value });
  },
}));
